module.exports = __webpack_public_path__ + "static/media/reg4kz.a42fee95.pdf";